import { FileDisplay as FileDisplayComponent } from 'components/Display/FileDisplay';
import { useSelector } from 'hooks/useSelector';
import React from 'react';
import { useDispatch } from 'react-redux';
import { getFileTypeFromUntrustedExtension } from 'service/file';
import { doFileDownload, doFilePreview } from 'store/actions';
import { selectAseFilesAst } from 'store/assessments/selectors';
import { selectAssetFiles } from 'store/assets/selectors';
import { FilesContext, FilesContextEnum } from 'types/types';

type Props = {
  context: FilesContext;
  value: string[];
  placeholder?: string;
};

export const FileDisplay: React.FC<Props> = ({
  context,
  value,
  placeholder,
}) => {
  const dispatch = useDispatch();
  const files =
    context.context === FilesContextEnum.remoteAssessment ||
    context.context === FilesContextEnum.localAssessment
      ? // eslint-disable-next-line react-hooks/rules-of-hooks
        useSelector(selectAseFilesAst)
      : // eslint-disable-next-line react-hooks/rules-of-hooks
        useSelector((state) => selectAssetFiles(state, context.assetId));

  const handlePreviewFile = React.useCallback(
    (fileId: string) => {
      const file = files[fileId];
      if (!file) {
        return;
      }
      const type = getFileTypeFromUntrustedExtension(file.type);
      if (!type) {
        return;
      }
      dispatch(
        doFilePreview({
          fileId: file.id,
          typeId: type.extension,
          context,
        }),
      );
    },
    [context, dispatch, files],
  );

  const handleDownloadFile = React.useCallback(
    (fileId: string) => {
      const file = files[fileId];
      if (!file) {
        return;
      }
      const type = getFileTypeFromUntrustedExtension(file.type);
      if (!type) {
        return;
      }
      dispatch(
        doFileDownload({
          fileId: file.id,
          typeId: type.extension,
          context,
        }),
      );
    },
    [context, dispatch, files],
  );

  return (
    <FileDisplayComponent
      files={files}
      fileIds={(value as string[] | undefined) || []}
      placeholder={placeholder}
      onPreview={handlePreviewFile}
      onDownload={handleDownloadFile}
    />
  );
};
